const antecipation = {
  title: 'O  que é a antecipação do <span>Saque-Aniversário?</span>',
  description:
    'É uma modalidade de crédito que permite antecipar, de uma só vez, o valor anual disponibilizado pelo FGTS no mês do seu aniversário.',
  list: [
    {
      text: 'E o desconto é feito <span>direto do seu FGTS</span>'
    },
    {
      text: 'O dinheiro cai na sua conta em <span>até 24 horas</span>'
    },
    {
      text: 'Você pode usar o <span>dinheiro como quiser</span>'
    }
  ],
  cta: {
    path: 'basic-data',
    id: 'lp-fgts-hero-form3-btn',
    label: 'Consultar',
    title: 'Descubra quanto você pode antecipar',
    trackClick: 'Simulacao_Dobra2'
  }
}

export default antecipation
